<form [formGroup]="form">
  <div class="row-24 grow">
    <div class="col-8 grow">
      <icz-section label="Jak chcete vyřídit">
        <icz-form-autocomplete [options]="generalTabFileSettlementTypeOptions" formControlName="fileSettlementType"
                               label="Způsob vyřízení spisu"></icz-form-autocomplete>
        @if (isBulkSettlementByOtherMethod) {
          <icz-form-autocomplete label="Jiný způsob vyřízení"
                                 formControlName="settlementMethodId"
                                 [options]="otherSettlementMethodsOptions">
          </icz-form-autocomplete>
        }
        <icz-date-picker [selectableDates]="isBulkValidSettlementDate" class="grow"
                         formControlName="settlementDate"
                         label="Datum vyřízení"
                         outputFormat="dateTime">
          <icz-icon size="small" suffix svgIcon="info"
                    tooltipText="Termín vyřízení nesmí být před datumem vzniku spisu.">
          </icz-icon>
        </icz-date-picker>
        @if (isBulkSettlementByRecord) {
          <div>
            <icz-form-field class="grow" formControlName="reason" label="Důvod"></icz-form-field>
            <icz-form-field class="grow" formControlName="content" label="Obsah"></icz-form-field>
          </div>
        }
        @if (isBulkSettlementByDocument) {
          <div>
            <icz-alert heading="Jako vyřizující dokument budou ve spisech vybrány naposledy vložené vlastní dokumenty." severity="info"></icz-alert>
          </div>
        }
      </icz-section>
      <icz-section label="Uzavření spisu">
        <div class="grow">
          <icz-checkbox formControlName="doCloseFile"
                        label="Společně s vyřízením spis také uzavřít"></icz-checkbox>
          <br>
        </div>
        @if (form.get('doCloseFile')!.value) {
          <icz-date-picker class="grow"
                           formControlName="closeDate" label="Datum uzavření" outputFormat="dateTime"></icz-date-picker>
        }
      </icz-section>
    </div>
    <div class="col-8 grow">
      <icz-section label="Přenastavit hromadně pro všechny vyřizované spisy">
        <icz-checkbox formControlName="useGlobalSettings" class="mb-16"
                      label="Pro všechny vyřizované spisy přenastavit věcnou skupinu nebo typ spisu"></icz-checkbox>
        @if (form.get('useGlobalSettings')!.value) {
          <icz-file-type-selector
            [date]="bulkSettlementDate"
            [form]="form"
            [mode]="VisibleClassifiersMode.VALID_AT_GIVEN_DATE"
            controlName="fileTypeId"
          ></icz-file-type-selector>
          <icz-entity-class-selector
            [form]="form"
            [showEntityClassesValidAt]="bulkSettlementDate"
            [usage]="EntityClassSelectorUsage.OFFICER_CURRENT_WITHOUT_V"
            controlName="entityClassId"
          ></icz-entity-class-selector>
          @if (entityClassId) {
            <div class="row-8 grow">
              <icz-date-picker class="grow" formControlName="entityClassValidFrom" label="Platnost věcné skupiny od" outputFormat="dateTime" placeholder="Neomezeno"></icz-date-picker>
              <icz-date-picker class="grow" formControlName="entityClassValidTo" label="Platnost věcné skupiny do" outputFormat="dateTime" placeholder="Neomezeno"></icz-date-picker>
            </div>
          }
        }
      </icz-section>
    </div>
  </div>
  <div class="row grow">
    <div class="col grow">
      @if (form.get('useGlobalSettings')!.value) {
        <icz-section class="grow" label="Skartační režim">
          <div class="row-24 grow">
            <div class="col grow">
              <icz-form-field formControlName="disposalOperationCode" label="Výsledný skartační znak"></icz-form-field>
              <icz-form-field formControlName="disposalYear" label="Předpokládaný rok vyřazení"></icz-form-field>
              <icz-form-autocomplete
                [clearable]="false"
                [options]="retentionTriggerTypesOptions"
                class="grow"
                formControlName="retentionTriggerTypeCode"
                label="Spouštěcí událost"
              ></icz-form-autocomplete>
              @if (isExternalRetentionTriggerTypeWithPeriod()) {
                <icz-ext-retention-trigger-selector
                  [form]="form"
                  [availableExternalRetentionTriggerIds]="form.get('externalRetentionTriggerIds')!.value ?? []"
                ></icz-ext-retention-trigger-selector>
              }
            </div>
            <div class="col grow">
              <div class="row">
                <icz-form-field class="grow" label="Rok spouštěcí události"  formControlName="yearOfRetentionPeriodStart" type="integer"></icz-form-field>
                @if (isRetentionTriggerTypeWithPeriod()) {
                  <icz-form-field class="grow" label="Rok kontroly spouštěcí události"  formControlName="triggerEventCheckYear" type="integer"></icz-form-field>
                } @else {
                  <div class="grow"></div>
                }
              </div>
            </div>
          </div>
        </icz-section>
      }
    </div>
  </div>
</form>
